import { useEffect, useRef } from "react";

let SCRIPT_LOADED = false;

function ensureElfsightScript() {
    if (SCRIPT_LOADED) return;
    if (document.querySelector('script[src="https://elfsightcdn.com/platform.js"]')) {
        SCRIPT_LOADED = true;
        return;
    }
    const s = document.createElement("script");
    s.src = "https://elfsightcdn.com/platform.js";
    s.async = true;
    document.head.appendChild(s);
    SCRIPT_LOADED = true;
}

/**
 * Wrapper for Elfsight widgets.
 * Renders a div with the widget's unique class and lazy-loads the Elfsight platform script.
 */
export default function ElfsightWidget({ appId, className = "" }) {
    const ref = useRef(null);

    useEffect(() => {
        ensureElfsightScript();
        // Tell elfsight to (re-)scan the DOM in case the script was already loaded
        if (window.eapps && typeof window.eapps.AppsManager?.initAll === "function") {
            try {
                window.eapps.AppsManager.initAll();
            } catch (err) {
                console.warn("Elfsight: initAll failed:", err);
            }
        }
    }, [appId]);

    return (
        <div
            ref={ref}
            className={`elfsight-app-${appId} ${className}`}
            data-elfsight-app-lazy=""
        />
    );
}
